import { ChartData, ChartOptions } from "chart.js";
import { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";

interface IHarveyBallChart {
  percentage: number
}

const HarveyBallChart: React.FC<IHarveyBallChart> = ({ percentage }) => {
  
  const fillLevel = useMemo(() => { return Math.ceil(percentage / 25) * 25 }, [percentage]);

  const createHarveyBallData = (weight: number): ChartData<'doughnut'> => ({
    datasets: [
      {
        data: [weight, 100 - weight],
        backgroundColor: ['#1e3a8a', '#ffffff'],
        borderColor: '#4a5568',
        borderWidth: 1,
      },
    ],
    labels: ['', ''],
  });

  const chartOptions: ChartOptions<'doughnut'> = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    cutout: '0%',
    circumference: 360, 
    maintainAspectRatio: true, 
    responsive: true,
    layout: {
      padding: 2,
    },
  };

  return (
    <div className="w-7 h-7  flex items-center justify-center">
      <Doughnut
        data={createHarveyBallData(fillLevel)}
        options={chartOptions}
        width={24}
        height={24} 
      />
    </div>

  );
};

export default HarveyBallChart